/**
 * @beta
 */
export const callEach = (...fns: (Function | undefined)[]) => fns.forEach(fn => fn && fn())
